import React from 'react';
import { motion } from 'framer-motion';

import Card from '../../shared/components/UIElements/Card';
import Button from '../../shared/components/FormElements/Button/Button';
import './Interview.css';

const Question = props => {

    return (
        <React.Fragment>
        <motion.li 
            className="interview-item"
            initial={{ opacity: 0, x: -1200 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.25+0.1*props.index, duration: 1 }}
        >
            <Card className="interview-item__content">
                    <Button to={`/question/evaluation/${props.id}`} transparent_100>
                    <p>{props.question}</p>
                    </Button>
            </Card>
        </motion.li>
        </React.Fragment>
        );

};

export default Question;